export default __webpack_public_path__ + "static/09.03-8f7e36e46c6891288a935491d0595287.png";